import React from "react";
import { WifiOff, CloudUpload } from "lucide-react";
import useOfflineSync from "../hooks/useOfflineSync";

export default function OfflineBadge({ className = "" }) {
  const { online, pendingCount, syncing, showOfflineBadge } = useOfflineSync();

  if (!showOfflineBadge) return null;

  const label = !online
    ? "Modalità offline · sync in coda"
    : pendingCount > 0
      ? `Sync in coda (${pendingCount})`
      : null;

  if (!label) return null;

  return (
    <span
      className={`offline-badge ${className}`.trim()}
      data-testid="offline-badge"
      title={syncing ? "Sincronizzazione in corso…" : label}
      role="status"
    >
      {!online ? <WifiOff size={12} aria-hidden /> : <CloudUpload size={12} aria-hidden className={syncing ? "animate-pulse" : ""} />}
      <span className="offline-badge__text">{label}</span>
    </span>
  );
}
